import React from 'react';

function Footer() {
    return (
        <div className="footer">
            <p>⭯ <a href="https://dev.azure.com/ExergyManagementLab/_git/Outlook2SageX">2.6.2</a> / Octobre 2025 - ✉ <a href="mailto:francois.brouchoud@hevs.ch">francois.brouchoud@hevs.ch</a></p>
        </div>
    );
}

export default Footer;
